import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@metarouter-private/mr-mui';
import IntegrationAvatar from 'app/shared/components/integrations/IntegrationAvatar';

const DEFAULT_STACK_PROPS = {
  alignItems: 'center',
  direction: 'row',
  spacing: 1,
};

const DEFAULT_TYPOGRAPHY_PROPS = {
  ellipsis: true,
};

export default function IntegrationAvatarAndName({
  integration,
  StackProps = {},
  AvatarProps = {},
  TypographyProps = {},
}) {
  return (
    <Stack {...DEFAULT_STACK_PROPS} {...StackProps}>
      <IntegrationAvatar {...AvatarProps} starterkitId={integration.starterkitId} />
      <Typography {...DEFAULT_TYPOGRAPHY_PROPS} {...TypographyProps}>
        {integration.name}
      </Typography>
    </Stack>
  );
}

IntegrationAvatarAndName.propTypes = {
  integration: PropTypes.shape({
    starterkitId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  StackProps: PropTypes.object,
  AvatarProps: PropTypes.object,
  TypographyProps: PropTypes.object,
};
